
import { Space } from "antd";

import styles from "./DataAccess.module.scss";

import { ParquetFileForm } from "../ParquetFileForm/ParquetFileForm";

export const DataAccess = () => {
  return (
    <div className={styles.root}>
      <Space direction="vertical" size={16} className={styles.wrapper}>
        <ParquetFileForm />
      </Space>
    </div>
  );
};
